/* 库存调整 */
const report = {
  sale:"/salemng/saleOutStock/statistics",//销售统计
  purchasemng:"/purchasemng/purchaseinstock/statistics",//采购统计
  currentInventory:"/stockmng/currentInventory/query",//当期库存
  period:"/stockmng/periodinventory/statistics",//期间库存
  periodinventory:"/stockmng/periodinventory/periodmtrljxc",//期间物料进销存
  materialreport:"/materialreport/statistics",//物料移动报表
}
export{
	report
}
